import { useContext } from "react";
import { CommandPaletteContext } from "../providers/CommandPaletteProvider";
import type { CommandPaletteContextValue } from "../providers/CommandPaletteProvider";

// Consumer hook for the command-palette open/close handle. Throws when called
// outside the provider tree so the bug is loud rather than silent.
export function useCommandPalette(): CommandPaletteContextValue {
    const ctx = useContext(CommandPaletteContext);
    if (!ctx) throw new Error("useCommandPalette must be used within a CommandPaletteProvider");
    return ctx;
}
